import axios from '@/axios';

export default {
	namespaced: true,

	actions: {
		async fetchLanguageFilters() {
			return axios.get('/Helper/Languages').then(({ data }) => data);
		},
		async fetchComputerFilters() {
			return axios.get('/Helper/ComputerSkills').then(({ data }) => data);
		},
		async fetchExpertiseFilters() {
			return axios.get('/Helper/Skills').then(({ data }) => data);
		},
		async fetchCoursesFilters() {
			return axios.get('/Helper/Courses').then(({ data }) => data);
		},
		async fetchCompanyFilters() {
			return axios.get('/Helper/Companies').then(({ data }) => data);
		},
		async fetchPrevJobFilters() {
			return axios.get('/Helper/OldJobs').then(({ data }) => data);
		},
		async fetchSpecificationFilters() {
			return axios.get('/Helper/Qualifications').then(({ data }) => data);
		},
		async fetchOldJobsFilters() {
			return axios.get('/Helper/OldJobs').then(({ data }) => data);
		},

		async fetchVacationsTypes(_, id) {
			return axios.get('/SettingsHr/LeavesOrPermissionType/' + id).then(({ data }) => data);
		},
		async fetchMissionTypes() {
			return axios.get('/SettingsHr/TaskTypes').then(({ data }) => data);
		},
		async fetchJobDescriptions() {
			return axios.get('/Helper/JobDescriptions').then(({ data }) => data);
		},
	},
};
